import { API } from '@/shared/api/modules';
import type { GetFacilityByIdRequestDto } from '@/shared/api/modules/facilities';
import { queryOptions } from '@tanstack/react-query';
import { transformFacilitySinglePageDtoToFacilitySinglePage } from './lib';

export const getFacilityByIdQueryOptions = (
  params = {} as GetFacilityByIdRequestDto
) =>
  queryOptions({
    queryKey: ['facilities', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getFacilityById(params, {
        signal,
      });
      return transformFacilitySinglePageDtoToFacilitySinglePage(response);
    },
    enabled: !!params.facilityId,
  });
